import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authenticationActions from '../../redux/actions/AuthenticationActions';

import SplitPageContainer from '../commonComponents/shared/SplitPageContainer';
import LoadingSpinner from '../commonComponents/util/LoadingSpinner';
import FadeoutErrorMessage from '../commonComponents/util/FadeOutErrorMessage';
import ValidatedInput from '../commonComponents/util/ValidatedInput';
import queryString from 'query-string';

class PasswordResetPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            passwordConfirm: '',
            validPassword: false,
            token: queryString.parse(this.props.location.search).token
        };

        this.onChange = this.onChange.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    validatePassword(password) {
        const validPassword = !password || /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(password);
        this.setState({ validPassword });
        return validPassword;
    }

    async resetPassword() {
        await this.props.actions.resetPassword(this.state.token, this.state.password);

        if (this.props.success) {
            this.props.history.push('/login', { resetPasswordRedirect: true });
        } else {
            this.setState({ password: '', passwordConfirm: '', validPassword: false });
            if(this.props.expired) this.props.history.push('/recover-password', { expiredResetTokenRedirect: true });
        }
    }

    render() {
        return (
            <SplitPageContainer
                title={this.props.location.pathname === "/reset-password" ?
                 "Password Reset" : "Set Password"}
                subtitle={`Please enter ${this.props.location.pathname === "/reset-password" ? "your new" : "a"} password.`}>
                <div>
                    <ValidatedInput input={<input type="password" />}
                        label="Password" name="password" value={this.state.password} onChange={this.onChange}
                        validated={true} showValidationError={true} validate={this.validatePassword.bind(this)}
                        errorMessage="Password must be at least 8 characters long, and must contain an uppercase and lowercase letter and a digit." />
                    <ValidatedInput input={<input type="password" disabled={!this.state.password || !this.state.validPassword}
                        onKeyDown={e => { if (e.key === 'Enter' && this.state.password === this.state.passwordConfirm) this.resetPassword() }} />}
                        label="Confirm Password" name="passwordConfirm" value={this.state.passwordConfirm} onChange={this.onChange}
                        validated={true} showValidationError={true} validate={val => !val || this.state.password === val}
                        errorMessage="Passwords do not match." />
                    <div className="left-column-footer relative">
                        {this.props.loading ? <LoadingSpinner height="32" /> :
                            <button className="btn btn-primary btn-wide" onClick={this.resetPassword}
                                disabled={!this.state.passwordConfirm || this.state.password !== this.state.passwordConfirm}>Submit</button>}

                        <FadeoutErrorMessage show={!this.props.success && !this.props.expired} />
                    </div>
                </div>
            </SplitPageContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.authentication.resetPassword
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage);



// WEBPACK FOOTER //
// ./src/components/authenticationComponents/PasswordResetPage.jsx